import React from "react";

const EmailAddress = ({ email }) => email;

export default EmailAddress;
